// extracted by mini-css-extract-plugin
export default {"emboldened":"ContentfulRiver-module__emboldened--_jFJV"};